// FORGE Signet „Der Funke" — glühender O-Ring mit Kerbe und Funke.
// Eine Quelle für alle Seiten-Header (Coming-Soon, Legal, Onboarding);
// identisch mit public/favicon.svg (dort mit Navy-Kachel als Hintergrund).
let _uid = 0;

export function signetSVG(size, style = 'display:block') {
  const id = 'sig-g' + (++_uid);
  return `<svg width="${size}" height="${size}" viewBox="0 0 32 32" aria-hidden="true" style="${style}">
    <defs><linearGradient id="${id}" x1="0" y1="1" x2="1" y2="0">
      <stop offset="0" stop-color="#C94D1A"/><stop offset=".5" stop-color="#E85D24"/><stop offset="1" stop-color="#F5A623"/>
    </linearGradient></defs>
    <circle cx="16" cy="16" r="8.5" fill="none" stroke="#E85D24" stroke-width="7.5" opacity=".2"/>
    <circle cx="16" cy="16" r="8.5" fill="none" stroke="url(#${id})" stroke-width="4" stroke-linecap="round" stroke-dasharray="45 8.4" transform="rotate(-79 16 16)"/>
    <circle cx="22.4" cy="9.6" r="2" fill="#F5C623"/>
  </svg>`;
}

// Wortmarke „F⊙RGE" — das Signet IST das O (Konzept „Der Funke": glühendes O).
// oSize = Kantenlänge des Signet-SVGs in px, ca. 1,2 × font-size der Wortmarke.
// Erbt Font, Farbe und letter-spacing vom umgebenden Element.
export function wordmarkHTML(oSize) {
  return `<span style="display:inline-flex;align-items:center;white-space:nowrap">F${signetSVG(oSize)}RGE</span>`;
}
